import React, { useState } from "react";
import { Link } from "react-router-dom";
import { showNotification } from "../../config";
import { ReactComponent as IlusIcon } from "../../inlineSvgs/ilus.svg";
import { ReactComponent as IlusRedIcon } from "../../inlineSvgs/ilus-red.svg";
import { ReactComponent as CopyIcon } from "../../inlineSvgs/copy.svg";
import { ReactComponent as PhoneIcon } from "../../inlineSvgs/phone-sup.svg";
import { ReactComponent as CopyWIcon } from "../../inlineSvgs/copy-w.svg";
import { ReactComponent as PhoneWIcon } from "../../inlineSvgs/phone-sup-w.svg";

const OrderCanceling = ({ setDeleting, removeOrder, withPenalty }) => {
  const [isSuccess, setSuccess] = useState(false);
  const [checkbox, setCheckbox] = useState(false);

  const processingRemoveOrder = async () => {
    try {
      await removeOrder();
      setSuccess(true);
    } catch {
      showNotification("Failed to delete order");
    }
  };

  if (isSuccess) {
    return (
      <div className={withPenalty ? "order-deleting success penalty" : "order-deleting success"}>
        <div className="order-deleting__img">{withPenalty ? <IlusIcon /> : <IlusRedIcon />}</div>
        <div className="title">Booking canceled successfully</div>
        <div className="sub-title">
          {withPenalty 
          ? "Booking successfully cancelled, you have successfully paid the fine. We are sorry that this happened, and hope to see you soon."
          : "Booking canceled successfully. We are sorry that this happened. We hope for your soon return."}
        </div>
        <Link to="/" className="beauty-btn fill" onClick={() => setDeleting(false)}>
          Go Main Page
        </Link>
      </div>
    );
  }

  return (
    <div className={withPenalty ? "order-deleting penalty" : "order-deleting"}>
      <div className="order-deleting__img">{withPenalty ? <IlusIcon /> : <IlusRedIcon />}</div>

      <h3 className="title">Cancellation of booking </h3>

      <p className="sub-title">
        {withPenalty
          ? "You try to cancel your booking less than three hours before the start time, this will result in the cancellation of your booking and a 50% penalty. If you want to change the time or services, you can contact support."
          : "You try to cancel a booking, this will lead to the deletion of your order. If you want to change the time or services, you can contact support."}
      </p>

      <div className="contacts">
        <a className="sup-link" href="meilto:support@monlis.de">
          support@monlis.de {withPenalty ? <CopyWIcon /> : <CopyIcon />}
        </a>
        <a className="sup-link" href="tel:+49 1514 1619858">
          +49 1514 1619858 {withPenalty ? <PhoneWIcon /> : <PhoneIcon />}
        </a>
      </div>

      <div className="understand-box">
        <label htmlFor="understand" className="container">
          {withPenalty
            ? "I understand that I am irrevocably canceling the booking. For which I will be fined."
            : "I understand that, I am irrevocably canceling the booking."}
          <input
            type="checkbox"
            id="understand"
            name="understand"
            checked={checkbox}
            onChange={() => setCheckbox(!checkbox)}
          />
          <span class="checkmark"></span>
        </label>
      </div>

      <button className="beauty-btn border" onClick={processingRemoveOrder} disabled={!checkbox}>
        Yes, cancel
      </button>
      <button className="beauty-btn fill" onClick={() => setDeleting(false)}>
        Go Back
      </button>
    </div>
  );
};

export default OrderCanceling;
